define('views/modules/calendar/calendar/calendar-component/calendar-day',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils', 'bootbox',
    // Views
    'views/parts/menu/menu-context',
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-sortable-list',
    //services
    'services/events/calendar-events',
    'services/user',
    'services/i18n',
    // Templates
    'text!templates/modules/calendar/calendar/calendar-component/calendar-day.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U, Bootbox,
    // Views
    VMenuContext,
    VCalendarItemSortableList,
    // services
    CalendarEvents,
    User,
    i18n,
    // Templates
    TCalendarDay
) {

    var VCalendarDay = Backbone.View.extend({
        template: TCalendarDay,

        tagName: "td",
        className: "day",

        events: {
            "click .add-calendar-item-toggle": "toggleAddItemMenu"
        },

        regions: {
            menu: ".menu-options",
            list: ".calendar-items",
        },

        initialize: function(opt) {
            this.options = _.extend({}, {
                displayDate: true
            }, opt);

            _.extend(this, {
                date: moment(this.model.get('date')),
                role: opt.role
            });

            this.setUrl("parent", opt.url);
            this.setUrl("root", this.url.parent + this.date.format("YYYY-MM-DD"));

            var collection = this.collection = this.model.getItems();

            this.view = {
                list: new VCalendarItemSortableList({
                    collection: collection,
                    url: this.url.parent,
                    summary: false,
                    role: this.role
                })
            };

            this.listenTo(collection, { 'change:date': this.onItemDateChange });
        },

        initListener: function() {
            this.stopListeningTo(Backbone.history);
            this.listenTo(Backbone.history, "route", this.onRoute);
        },

        render: function() {
            this.initListener();

            var date = this.date,
                data = {
                    displayDate: this.options.displayDate,
                    daynumber: date.date(),
                    fulldate: date.format('dddd') + ", " + date.format('LL')
                };

            if (date.date() === 1) {
                data.shortMonth = date.format('MMM');
            }

            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(data)));

            this.generateZones()
                .assign(this.view.list, this.zone.$list)
                .setActive();

            this.addTodayClass()
                .addHasItemsClass();

            this.isMenuReady = true;

            // Initiate drag and drop to this items list
            return this;
        },

        isToday: function() {
            return this.date.isSame(new Date(), 'day');
        },

        addTodayClass: function() {
            if (this.isToday()) this.$el.addClass("today");
            return this;
        },

        addHasItemsClass: function() {
            this.$el.toggleClass("has-items", this.collection.length > 0);
        },

        setActive: function(val) {
            if (_.isUndefined(val)) val = Backbone.history.hasPrefix(this.url.root);
            this.$el.toggleClass("active", val);
            return this;
        },

        toggleAddItemMenu: function(e) {
            // Prevent Click Anchor
            e.preventDefault();
            var view = this.view,
                menu = view.menu,
                root = this.url.root;

            //Fix the bug when too many client. The calendar isn't refresh
            //fast enough and the contextual menu has the activity url set to another client.
            if (this.role === 'supervisor' && Backbone.history.getFragment().indexOf("member/me/") === -1) {
                var newRoot = root.substring(0, 51) + User.getCurrentlySelectedUser().get("_id") + root.substring(75);
                root = newRoot;
              }

            if (!menu) {
                var collection = new Backbone.Collection([
                    { route: root + '/activity/', caption: 'Activity', icon: 'sl-icon-note' },
                    { route: root + '/custom_data/', caption: 'Custom data', icon: 'sl-icon-user' },
                    { route: root + '/animated/', caption: 'calendar:Animated session', icon: 'sl-icon-energy' },
                    { route: root + '/nutrilog/', caption: 'calendar:Nutrition', icon: 'sl-icon-cup' }
                ]);

                if (this.role === 'client' && !User.get('_canViewAnimatedSessions')) {
                    collection.remove(collection.at(2));
                }

                // defer the creation of the option menu view
                menu = view.menu = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: collection
                });
                this.assign(menu, this.zone.$menu);
            }
            menu.toggle();
        },

        ////////////
        // events //
        ////////////
        onActionClick: function(e, item) {
            this.setActive();
        },

        onRoute: function(router, route, params) {
            this.setActive();
        },

        onDisable: function() {
            this.stopListeningTo(Backbone.history);
        },

        onItemDateChange: function(model, value, options) {
            if (!this.date.isSame(value)) {
                this.collection.remove(model);
                this.model.trigger('change:date', model);
            }
        },
    });

    return VCalendarDay;
});

